import React from 'react'

const
  ApiServiceContext = React.createContext(),
  PreloaderContext = React.createContext(),
  StorageContext = React.createContext(),
  BasketContext = React.createContext();

export {
  ApiServiceContext,
  PreloaderContext,
  StorageContext,
  BasketContext
}
